/**
 * Internal link market routing.
 *
 * Ported from the live theme. Canada sits on an /en-ca path prefix, so a link
 * written without it drops the customer back into the US market. Once the
 * prefix is present in the URL, every internal link is rewritten to carry it.
 *
 * Live ran this once on load. Here it also runs on later navigation and on
 * newly inserted content, since Horizon renders sections and cart contents
 * after the fact.
 */

const PREFIX_PATTERN = /^\/(en-ca)/i;

function currentPrefix() {
  return window.location.pathname.match(PREFIX_PATTERN)?.[1] || null;
}

function rewrite(root, prefix) {
  const links = root instanceof Element ? root.querySelectorAll('a[href]') : [];

  links.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    // Absolute links to the storefront that are missing the prefix.
    if (/^https?:\/\/(www\.)?pehr\.com\/(?!en-ca)/i.test(href)) {
      const path = href.replace(/^https?:\/\/(www\.)?pehr\.com/i, '');
      link.href = `/${prefix}${path}`;
      return;
    }

    // Root relative links that are missing the prefix. Protocol relative and
    // anchor links are left alone.
    if (/^\/(?!\/)(?!en-ca)/.test(href)) {
      link.href = `/${prefix}${href}`;
    }
  });
}

function run(root) {
  const prefix = currentPrefix();
  if (!prefix) return;
  rewrite(root || document, prefix);
}

run();

// Sections, the cart drawer and search results all inject links after load.
const observer = new MutationObserver((records) => {
  const prefix = currentPrefix();
  if (!prefix) return;

  records.forEach((record) => {
    record.addedNodes.forEach((node) => {
      if (node.nodeType !== 1) return;
      if (node.matches?.('a[href]')) rewrite(node.parentElement, prefix);
      rewrite(node, prefix);
    });
  });
});

observer.observe(document.documentElement, { childList: true, subtree: true });

document.addEventListener('shopify:section:load', () => run());
